import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "./ui/dialog";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { categories } from "../mock";
import { submitPlace } from "../api";
import { toast } from "sonner";

const empty = { name: "", category: "", type: "", area: "", note: "", rating: "" };

const SubmitSpotDialog = ({ open, onOpenChange, onCreated }) => {
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async () => {
    if (!form.name || !form.category || !form.type || !form.area || !form.note) {
      toast.error("please fill in name, category, type, area and a short note.");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        name: form.name.trim(),
        category: form.category,
        type: form.type.trim(),
        area: form.area.trim(),
        note: form.note.trim(),
        rating: form.rating ? parseFloat(form.rating) : null,
      };
      const created = await submitPlace(payload);
      toast.success(`added “${created.name}” to dilli.wiki — thank you!`);
      setForm(empty);
      onOpenChange(false);
      onCreated && onCreated(created);
    } catch (e) {
      toast.error("could not submit right now. try again in a bit.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle>Submit a spot</DialogTitle>
          <DialogDescription>
            know a place delhi should know about? add it and it shows up instantly.
          </DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 py-1">
          <div className="grid gap-1.5">
            <Label htmlFor="name">Name</Label>
            <Input id="name" value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="e.g. Changezi Chicken" />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="grid gap-1.5">
              <Label>Category</Label>
              <Select value={form.category} onValueChange={(v) => set("category", v)}>
                <SelectTrigger>
                  <SelectValue placeholder="Pick one" />
                </SelectTrigger>
                <SelectContent>
                  {categories.map((c) => (
                    <SelectItem key={c.id} value={c.id}>{c.label}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="grid gap-1.5">
              <Label htmlFor="rating">Rating (optional)</Label>
              <Input id="rating" type="number" step="0.1" min="0" max="5" value={form.rating} onChange={(e) => set("rating", e.target.value)} placeholder="4.5" />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="grid gap-1.5">
              <Label htmlFor="type">Type</Label>
              <Input id="type" value={form.type} onChange={(e) => set("type", e.target.value)} placeholder="Mughlai restaurant" />
            </div>
            <div className="grid gap-1.5">
              <Label htmlFor="area">Neighbourhood</Label>
              <Input id="area" value={form.area} onChange={(e) => set("area", e.target.value)} placeholder="Old Delhi" />
            </div>
          </div>

          <div className="grid gap-1.5">
            <Label htmlFor="note">The one-liner</Label>
            <Textarea id="note" value={form.note} onChange={(e) => set("note", e.target.value)} placeholder="why should someone go? keep it short and punchy." rows={3} />
          </div>
        </div>

        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={saving}>Cancel</Button>
          <Button onClick={submit} disabled={saving} className="bg-neutral-900 text-white hover:bg-neutral-800">
            {saving ? "Adding…" : "Add spot"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SubmitSpotDialog;
